import { render, staticRenderFns } from "./MyCommentedEntries.vue?vue&type=template&id=be30707e"
import script from "./MyCommentedEntries.vue?vue&type=script&lang=js"
export * from "./MyCommentedEntries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports